export const SET_SELECTED_PATIENT = "SET_SELECTED_PATIENT";
export const SET_PROVIDER_ABOUT_MODAL = "SET_PROVIDER_ABOUT_MODAL";
export const SET_PROVIDER_MAIL = "SET_PROVIDER_MAIL";
export const SET_NO_USER_FOUND = "SET_NO_USER_FOUND";
export const SET_PROFILE_IMAGE_UPDATE_FLAG = "SET_PROFILE_IMAGE_UPDATE_FLAG";
export const SET_PROFILE_IMAGE_UPDATE_FLAG_V2 = "SET_PROFILE_IMAGE_UPDATE_FLAG_V2";
export const SET_IS_PROVIDER_PHOTO_AVAILABLE = "SET_IS_PROVIDER_PHOTO_AVAILABLE";
export const SET_IS_PROFILE_COMPLETE = "SET_IS_PROFILE_COMPLETE";

export const setSelectedPatient = (payload) => {
   return {
      type: SET_SELECTED_PATIENT,
      payload,
   };
};
export const setNoUserFound = (payload) => {
   return {
      type: SET_NO_USER_FOUND,
      payload,
   };
};
export const setProviderAboutModal = (payload) => {
   return {
      type: SET_PROVIDER_ABOUT_MODAL,
      payload,
   };
};

export const setOnboardProviderEmail = (payload) => {
   return {
      type: SET_PROVIDER_MAIL,
      payload,
   };
};

export const setProfileImageUpdateFlag = () => {
   return {
      type: SET_PROFILE_IMAGE_UPDATE_FLAG,
   };
};

export const setProfileImageUpdateFlagV2 = () => {
   return {
      type: SET_PROFILE_IMAGE_UPDATE_FLAG_V2,
   };
};

export const setIsProviderPhotoAvailable = (payload) => {
   return {
      type: SET_IS_PROVIDER_PHOTO_AVAILABLE,
      payload,
   };
};
export const setIsProfileComplete = (payload) => {
   return {
      type: SET_IS_PROFILE_COMPLETE,
      payload,
   };
};
